import React from 'react';
import { Container, ContentContainer } from '../shared/styles';
import Actions from './series-components/actions';
import SeriesTable from './series-components/series-table';

export default function Series() {
  return (
    <Container>
      <ContentContainer>
        <SeriesTable />
      </ContentContainer>
      <Actions />
    </Container>
  );
}
